import { Box } from "@mui/material"
import React from "react"

// A local variant of ../businesses/TabPanel.tsx: that one wraps children in a MUI
// <Typography>, which renders a <p> — invalid HTML (and broken layout) once nested content
// includes Cards/Boxes/Grids like this screen's panels do.
export const WheelTabPanel: React.FC<{ value: number; index: number; children: React.ReactNode }> = ({
  value,
  index,
  children,
}) => (
  <div role="tabpanel" hidden={value !== index} id={`wheel-tabpanel-${index}`} aria-labelledby={`wheel-tab-${index}`}>
    {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
  </div>
)

export const wheelTabA11yProps = (index: number) => ({
  id: `wheel-tab-${index}`,
  "aria-controls": `wheel-tabpanel-${index}`,
})
